const MASTER_AUTH_TOKEN = "master_token";

export function getMasterTokenFromCookies() {
  return localStorage.getItem(MASTER_AUTH_TOKEN) || "";
}

export function flushMasterTokenFromCookies() {
  localStorage.removeItem(MASTER_AUTH_TOKEN);
}
export function getMasterAuthorizationHeader() {
  return `Bearer ${getMasterTokenFromCookies()}`;
}
